/* This example requires Tailwind CSS v2.0+ */
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Hero from "components/organisms/common/Hero"
import useTranslations from "hooks/useTranslations"

const HeroImage = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      hero: file(relativePath: { eq: "pro/AdobeStock_393554767.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      loading="eager"
      image={getImage(data.hero)}
      className={className}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "top",
      }}
    />
  )
}

export default function HeroCourses() {
  const {
    schoolHeroHighlight,
    proCoursesHeroTitle1,
    proCoursesHeroDescription,
  } = useTranslations()
  return (
    <Hero
      Image={HeroImage}
      slides={[proCoursesHeroTitle1]}
      description={proCoursesHeroDescription}
      bgColor="black"
      searchWords={schoolHeroHighlight || [""]}
      buttonType="contact"
    />
  )
}
